import { render, staticRenderFns } from "./invoice-detail-modal.vue?vue&type=template&id=542b3afe&scoped=true&"
import script from "./invoice-detail-modal.vue?vue&type=script&lang=js&"
export * from "./invoice-detail-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542b3afe",
  null
  
)

export default component.exports